import { useMemo } from 'react'

import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'
import { usePagination } from '@/utils/pagination/pagination-context.tsx'

import { getLinkTracking } from '../data/service'
import { type LinkType } from '../types'

interface UseLinkTracking {
  type: LinkType
  onlyVisible: boolean
}

export const useLinkTracking = ({ type, onlyVisible }: UseLinkTracking) => {
  const creatorId = useUnit($creatorId)
  const { pagination } = usePagination()

  const { data, isFetching, isIdle } = useQuery(
    ['linkTracking', creatorId, type, onlyVisible, pagination],
    () => {
      return getLinkTracking({
        creatorId: creatorId!,
        type,
        onlyVisible,
        pagination: {
          size: pagination.pageSize,
          page: pagination.pageIndex,
        },
      })
    },
    {
      retry: false,
      enabled: !!creatorId,
      onError: (error) =>
        handleError(error, 'Failed to get link tracking data'),
    },
  )

  return useMemo(() => {
    return {
      data,
      isFetching: isFetching || isIdle,
    }
  }, [data, isFetching, isIdle])
}
